// Etiquetas de los grupos de almacén del reporte de consumo
export const ETIQUETAS_TIPO_ALMACEN = {
    materia_prima: "Materia prima",
    reproceso: "Reproceso",
};

// Los almacenes vienen ordenados por tipo desde el backend, así que la fila
// combinada del encabezado solo agrupa los que van seguidos
export const agruparAlmacenesPorTipo = (almacenes) => {
    const grupos = [];

    almacenes.forEach((almacen) => {
        const grupoActual = grupos.length ? grupos[grupos.length - 1] : null;

        if (grupoActual && grupoActual.tipo === almacen.tipo) {
            grupoActual.columnas += 1;
            return;
        }

        grupos.push({ tipo: almacen.tipo, columnas: 1 });
    });

    return grupos;
};
